export default __webpack_public_path__ + "static/jameson-ff251015cfbd635772fcd3f17bf7fd97.png";